export const APP_BAR_STATE_ITEMS = 'edi-app-bar:state:items';
export const APP_BAR_STATE_STUDENT_SEARCH = 'edi-app-bar:state:studentSearch';
export const APP_BAR_NAVIGATED = 'edi-app-bar:navigated';
export const APP_BAR_DRAWER_CLOSED = 'edi-app-bar-drawer:closed';
export const APP_BAR_FAVORITED = 'edi-app-bar:favorited';
export const APP_BAR_UNFAVORITED = 'edi-app-bar:unfavorited';
